<script lang="ts" setup>
import { PagesPrefixEnum } from '~/enums/PagesPrefixEnum'
import { Routes } from '~/enums/Routes'

defineProps<{
  isPro?: boolean
}>()
const router = useRouter()
const showCalculationFooter = ref<boolean>(false)
const { isWhitelabel, isNoriuLive } = useTheme()
const logos = await useAssetManager().getLogos()

if (Routes.Pro.includes(String(router.currentRoute.value.name).replace(PagesPrefixEnum, ''))) {
  showCalculationFooter.value = true
}
</script>

<template>
  <ProCalculateFooter v-if="isPro" />
  <footer>
    <template v-if="!isNoriuLive && !isWhitelabel">
      <section class="newsletter py-6 lg:py-[60px] text-white">
        <Newsletter />
      </section>
      <hr class="my-4 lg:my-6" />
    </template>
    <section class="footer pt-8 lg:pt-12 text-white wl:text-text2 dark:text-dmText2">
      <Container>
        <FaqContactsJav />
        <template v-if="isWhitelabel">
          <hr class="mt-4 lg:mt-6" />
          <div class="py-3 lg:py-8">
            <NuxtLink :to="getLocalizedRoute(Routes.Index)" class="lg:min-w-80">
              <img :src="logos.logoWhite" class="logo" alt="Logo" />
            </NuxtLink>
          </div>
        </template>
      </Container>

      <hr class="my-4 lg:my-6" />
      <Copyright />
    </section>
  </footer>
</template>

<style lang="postcss" scoped>
footer {
  @apply bg-brand-footer;

  section {
    @apply text-white;
  }

  hr {
    @apply my-6 border-t border-white;
  }
}

.wl {
  footer {
    @apply border-t-[5px] border-brand-primary;

    hr {
      @apply border-neutral5;
    }
  }
}

.nl {
  footer {
    @apply border-t-[1px] border-brand-primaryLight;

    hr {
      @apply border-text1;
    }
  }
}

.ae {
  footer {
    section {
      @apply text-text1;
    }
  }
}
</style>
